import { useMutation } from "@tanstack/react-query"
import { useSearchParams } from "react-router-dom"
import axios from "axios"
import { QUERY_PARAMS_EXCHANGE_TOKEN_KEY } from "../../../utils/constants"
import { IIdentificationResponse } from "./interface"

const API_IDENTIFICATION_URL = `${window.extended.REACT_APP_API_URL}/api/identification-2`

const sendIdentificationRequest = async (exchangeToken: string | null) => {
  const response = await axios(API_IDENTIFICATION_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${exchangeToken}`,
    },
  })
  return response.data
}

export const useIdentification = () => {
  const [searchParams] = useSearchParams()
  const exchangeToken = searchParams.get(QUERY_PARAMS_EXCHANGE_TOKEN_KEY)

  return useMutation<IIdentificationResponse, void, { token?: string }>({
    mutationFn: ({ token }) =>
      sendIdentificationRequest(token || exchangeToken),
    retry: false,
  })
}
